export default __webpack_public_path__ + "static/media/onboarding-poster.8c25ed97.png";